import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

// 创建独立的后台管理系统i18n实例
const adminI18n = i18n.createInstance()

adminI18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      /* 后台管理系统专用的翻译文件路径 */
      loadPath: '/assets/i18n/admin/{{lng}}.json'
    },
    fallbackLng: 'en',
    debug: true,
    /* 预加载所有支持的语言，避免异步加载导致的重新渲染 */
    preload: ['en', 'ar-AE'],
    /* 后台管理系统使用单独的命名空间 */
    ns: ['admin'],
    defaultNS: 'admin',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true
    }
  })

// 从localStorage读取后台语言设置并应用
export const initializeAdminLanguage = () => {
  const savedAdminLang = window.localStorage.getItem('adminLang')
  const supportedLanguages = ['en', 'ar-AE']
  
  let targetLanguage = 'en' // 默认英语
  
  if (savedAdminLang && supportedLanguages.includes(savedAdminLang)) {
    targetLanguage = savedAdminLang
  }
  
  console.log(`Initializing admin i18n with language: ${targetLanguage}`)
  adminI18n.changeLanguage(targetLanguage)
  
  return targetLanguage
}

// 设置后台语言
export const setAdminLanguage = (language) => {
  const supportedLanguages = ['en', 'ar-AE']
  
  if (supportedLanguages.includes(language)) {
    window.localStorage.setItem('adminLang', language)
    adminI18n.changeLanguage(language)
    console.log(`Admin language changed to: ${language}`)
    return true
  } else {
    console.warn(`Unsupported admin language: ${language}`)
    return false
  }
}

// 获取当前后台语言
export const getCurrentAdminLanguage = () => {
  return adminI18n.language || window.localStorage.getItem('adminLang') || 'en'
}

export default adminI18n
